<template>
  <v-btn-form :title="title" :mode="isEdit" @close="cancel()">
    <v-flex v-if="!isEdit">
        <v-card-title>
          <span class="headline">{{item.name}}</span>
        </v-card-title>
        <v-card-text>
        </v-card-text>
    </v-flex>
    <v-form v-model="valid" ref="form">
      <v-flex v-if="isEdit">
          <v-card-text>
          <v-text-field
            label="Название"
            hint="Название метки"
            v-model="item.name"
            clearable
          ></v-text-field>
      </v-card-text>
    </v-flex>
    </v-form>
    <template #actions>
      <v-btn v-if="!isEdit" @click="edit = !edit">Изменить</v-btn>

      <v-btn v-if="isEdit" v-show="!isNew" @click="save">Сохранить</v-btn>
      <v-btn v-if="isEdit" v-show="!isNew" @click="remove">Удалить</v-btn>
      <v-btn v-if="isEdit" v-show="isNew" @click="add">Создать</v-btn>
      <v-spacer></v-spacer>
    </template>

  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import dialogs from '../common/dialogs'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'tag-form',
    components: {vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {}
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: null
      }
    },
    created () {
      if (this.model == null) {
        this.item = this.getItemNew()
      } else {
        this.item = Object.assign({}, this.model)
      }
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
      }),
      isEdit () {
        return this.edit || this.isNew
      },
      isNew () {
        // return true
        // Disable functionality to change chat definition
        return this.itemId === null
      },
      title () {
        return this.isNew ? 'Создание метки' : this.isEdit ? 'Изменение метки' : 'Информация о метке'
      }
    },
    methods: {
      add () {
        const cb = (data) => {
          this.$emit('refresh')
          this.cancel()
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении метки '})
        }
        server.apiPost(
          '/api/me/tags',
          this.item.name,
          cb,
          cbError)
        this.edit = false
      },
      save () {
        const cb = (data) => {
          this.$emit('refresh')
          this.cancel()
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении метки '})
        }
        server.apiPut(
          '/api/me/tags/' + this.item.id,
          {name: this.item.name},
          cb,
          cbError)
        this.edit = false
      },
      remove () {
        const cb = (data) => {
          this.$emit('refresh')
          this.cancel()
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении метки '})
        }
        dialogs.confirm(this, 'Подтвердите', 'Удалить метку?',
          (self) => {
            server.apiDelete(
            '/api/me/tags/' + self.item.id,
            cb,
            cbError)
          })
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          name: null
        }
      }
    }

  }

</script>




// WEBPACK FOOTER //
// TagForm.vue?05679fbe